
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/compliance-pro",
      function () {
        return require("private-next-pages/products/compliance-pro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/compliance-pro"])
      });
    }
  